<template>
  <div class="container">
    <div class="handle-box">
      <el-input size="small" v-model="singlequery.phone" clearable placeholder="充值号码"
                style="width: 180px;" class="handle-input mr10"></el-input>
      <el-input size="small" v-model="singlequery.batchNo" clearable maxlength="12" placeholder="批次号"
                style="width: 180px;" class="handle-input mr10"></el-input>
      <el-date-picker size="small" v-model="timeArr" type="daterange" unlink-panels range-separator="至"
                      start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      <el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
                 @click="getsnailShowRemittanceInfo" class="m_t_10 m_l_10">搜索</el-button>
      <el-button size="small" type="primary" :class="[theme]" @click="getAdd"
                 class="m_t_10">充值</el-button>
<!--      <el-button size="small" type="primary" :class="[theme]" @click="getAPPAdd"-->
<!--                 class="m_t_10">APP充值</el-button>-->
      <span style="font-weight: 600;line-height: 40px;margin-left: 10px;font-size: 14px;">
        当前可用缴费余额：
        <span style="color: #ff0000;font-size: 14px">{{ balance }}</span>
        兔兔币
      </span>
    </div>
    <el-table :data="singletableData" border class="table" ref="multipleTable"
              header-cell-class-name="table-header" :row-style="{ height: '20px' }" v-loading="loading"
              :cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe>
      <el-table-column prop="orderNo" label="订单号" align="center" width="300"></el-table-column>
      <el-table-column prop="batchNo" label="批次号" align="center"></el-table-column>
      <el-table-column prop="rechargeNumber" label="充值号码" align="center" width="130"></el-table-column>
      <el-table-column prop="money" label="划账金额" align="center"></el-table-column>
      <el-table-column prop="operateType" label="划账类型" align="center">
        <template #default="scope">
          <span v-if="scope.row.operateType == 'DRE'">代理商充值</span>
          <span v-if="scope.row.operateType == 'BRO'">批量回退</span>
          <span v-if="scope.row.operateType == 'DP'">代理商带预存</span>
        </template>
      </el-table-column>
      <el-table-column prop="operateTime" label="提交时间" width="180" align="center">
        <template #default="scope">
          {{ timestampToDateString2(scope.row.operateTime) }}
        </template>
      </el-table-column>
      <el-table-column prop="deductNumber" label="划账号码" align="center" width="130"></el-table-column>
      <el-table-column prop="balance" label="当前余额" align="center" width="130"></el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination background layout="total, sizes, prev, pager, next, jumper"
                     :current-page="singlequery.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
                     :page-size="singlequery.pageSize" :total="singletotal" @size-change="handleSizeChange"
                     @current-change="handlePageChange"></el-pagination>
    </div>

    <el-dialog title="充值" v-model="singleVisible" width="520px" @close="closesingleDialog">
      <el-form label-width="120px" :model="singleForm" ref="editForm">
        <el-form-item label="选择模式">
          <el-radio-group v-model="singleForm.type">
            <el-radio label="1">手动输入</el-radio>
            <el-radio label="2">批量模板</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="金额" v-if="singleForm.type == '1'">
          <el-radio-group v-model="singleForm.amount">
            <el-radio v-for="item in amountList" :key="item.value" :label="item.value" :value="item.value"
                      style="margin: 18px 10px;float: left;">
              {{ item.label }}
            </el-radio>
            <el-input v-model="singleForm.amount" size="small" placeholder="其他金额"
                      style="width: 160px;margin: 5px 10px;float: left;" type="number"></el-input>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="手机号码" prop="phones" v-if="singleForm.type == '1'">
          <el-input size="small" :rows="5" type="textarea" v-model="singleForm.phones" auto-complete="off"
                    placeholder="一行一个,英文逗号分隔,支持批量充值"></el-input>
        </el-form-item>
        <el-form-item label="示例" v-if="singleForm.type == '2'">
          <div style="display: flex;flex-direction: column;">
            <span>17012345678,10</span>
            <span>一行一个英文逗号分隔</span>
          </div>
        </el-form-item>
        <el-form-item label="上传文件" prop="" v-if="singleForm.type == '2'">
          <el-upload ref="uploadSingle" action="/api/Snail/topUp" :headers="token" :limit="1"
                     :on-success="uploadSingleSuccess" :auto-upload="false" :data="singleForm">
            <el-button size="small" type="primary" :class="[theme]"
                       style="margin-top: 40px;">选择文件</el-button>
            <div class="el-upload__tip">只能导入txt文件</div>
          </el-upload>
        </el-form-item>
        <el-form-item class="dis-end">
          <el-button size="small" @click="closesingleDialog">取消</el-button>
          <el-button size="small" type="primary" :class="[theme]" v-if="singleForm.type == '1'"
                     @click="getSnailTopUp">确定</el-button>
          <el-button size="small" type="primary" :class="[theme]" v-if="singleForm.type == '2'"
                     @click="submitSingleUpload">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="APP充值" v-model="APPVisible" width="450px" @close="closeAPPDialog">
      <el-form label-width="120px" :model="APPForm" ref="editForm">
        <el-form-item label="APP充值:" prop="bon">
          <el-radio-group v-model="APPForm.bon">
            <el-radio :label="true">开启</el-radio>
            <el-radio :label="false">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item class="dis-end">
          <el-button size="small" @click="closeAPPDialog">取消</el-button>
          <el-button size="small" type="primary" :class="[theme]" @click="getstopDxtApp">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { snailShowRemittanceInfo, snailTopUp, stopWNApp, WNEnabled, queryDeptBalance } from '../api/dijia.js';

export default {
  name: 'WNRecharge',
  data() {
    return {
      loading: false,
      theme: localStorage.getItem('theme'),
      singlequery: {
        pageIndex: 1,
        pageSize: 10,
        phone: '',
        batchNo: '',
        startTime: '',
        endTime: ''
      },
      singletableData: [],
      singletotal: 0,
      amountList: [{
        value: 10,
        label: '10兔兔币'
      },
        {
          value: 20,
          label: '20兔兔币'
        },
        {
          value: 30,
          label: '30兔兔币'
        },
        {
          value: 50,
          label: '50兔兔币'
        },
        {
          value: 100,
          label: '100兔兔币'
        },
        {
          value: 300,
          label: '300兔兔币'
        },
        {
          value: 500,
          label: '500兔兔币'
        }
      ],
      singleVisible: false,
      singleForm: {
        userId: localStorage.getItem('user'),
        phones: '',
        amount: '',
        type: '1'
      },
      balance: '',
      APPVisible: false,
      APPForm: {
        bon: false
      },
      timeArr: [],
      token: {
        Authorization: localStorage.getItem('token'),
        type: 'web',
        UserRole: localStorage.getItem('ms_role'),
        XSecurityVersion: 'v2',
      },
    };
  },
  created() {
    this.getsnailShowRemittanceInfo();
    queryDeptBalance().then(res => {
      if (res?.code === 200) {
        this.balance = res.data;
      } else {
        this.$message.error(res.message);
      }
    });
  },
  methods: {
    getTime() {
      let startTime = new Date(new Date());
      let endTime = new Date();
      this.timeArr.push(startTime);
      this.timeArr.push(endTime);
    },
    convertDateStringToTimestamp(dateString) {
      const parts = dateString.split('-');
      const year = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1;
      const day = parseInt(parts[2], 10);
      const date = new Date(year, month, day);
      return date.getTime();
    },
    toDateTimeStr(dateTime) {
      const date = new Date(dateTime);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    timestampToDateString2(timestamp) {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    getsnailShowRemittanceInfo() {
      if (this.timeArr.length > 0) {
        let data = {
          phone: this.singlequery.phone,
          batchNo: this.singlequery.batchNo,
          startTime: this.convertDateStringToTimestamp(this.toDateTimeStr(this.timeArr[0])),
          endTime: this.convertDateStringToTimestamp(this.toDateTimeStr(this.timeArr[1])) + 86399000,
          pageIndex: this.singlequery.pageIndex,
          pageSize: this.singlequery.pageSize
        };
        this.loading = true;
        snailShowRemittanceInfo(data).then(res => {
          if (res?.code === 200) {
            this.loading = false;
            this.singletableData = res.data.list;
            this.singletotal = res.data.total;
          } else {
            this.loading = false;
            this.$message.error(res.message);
          }
        });
      } else {
        let data = {
          phone: this.singlequery.phone,
          batchNo: this.singlequery.batchNo,
          pageIndex: this.singlequery.pageIndex,
          pageSize: this.singlequery.pageSize
        };
        snailShowRemittanceInfo(data).then(res => {
          if (res?.code === 200) {
            this.singletableData = res.data.list;
            this.singletotal = res.data.total;
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    closesingleDialog() {
      this.singleForm.type = '1';
      this.singleForm.phones = '';
      this.singleForm.amount = '';
      this.singleVisible = false;
    },
    getSnailTopUp() {
      if (this.singleForm.amount > this.balance) {
        this.$message.error('余额不足');
      } else {
        let data = {
          phones: this.singleForm.phones,
          amount: this.singleForm.amount,
          type: this.singleForm.type,
          file: this.singleForm.file,
          userId: localStorage.getItem('user')
        };
        snailTopUp(data).then(res => {
          if (res?.code === 200) {
            this.getsnailShowRemittanceInfo();
            this.singleVisible = false;
            this.$confirm(res.data, '提示', {
              type: 'success',
              confirmButtonText: '复制',
            })
                .then(() => {
                  let cInput = document.createElement('input');
                  cInput.value = res.data;
                  document.body.appendChild(cInput);
                  cInput.select();
                  document.execCommand('copy');
                  this.$message.success('复制成功');
                  document.body.removeChild(cInput);
                })
                .catch(() => { });
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    getAdd() {
      this.singleVisible = true;
    },
    getAPPAdd() {
      this.APPVisible = true;
      this.getdxtEnabled();
    },
    getstopDxtApp() {
      let data = {
        bon: this.APPForm.bon,
        userId: localStorage.getItem('user')
      };
      stopWNApp(data).then(res => {
        if (res?.code === 200) {
          this.$message.success(res.data);
          this.APPVisible = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getdxtEnabled() {
      WNEnabled().then(res => {
        if (res?.code === 200) {
          this.APPForm.bon = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    closeAPPDialog() {
      this.APPVisible = false;
    },
    uploadSingleSuccess(success) {
      setTimeout(() => {
        this.$refs.uploadSingle.clearFiles();
      }, 2000);
      if (success?.code === 200) {
        this.singleVisible = false;
        this.$message.success('上传成功');
        setTimeout(() => {
          this.getsnailShowRemittanceInfo();
        }, 3000);
      } else {
        this.$message.error(success.message);
      }
    },
    submitSingleUpload() {
      if (this.$refs.uploadSingle.uploadFiles[0]) {
        this.loading = true;
        this.$refs.uploadSingle.submit();
      } else {
        this.$message.error('请选择上传文件');
      }
    },
    handlePageChange(val) {
      this.singlequery.pageIndex = val;
      this.getsnailShowRemittanceInfo();
    },
    handleSizeChange(val) {
      this.singlequery.pageSize = val;
      this.singlequery.pageIndex = 1;
      this.getsnailShowRemittanceInfo();
    },
  }
};
</script>

<style scoped>
.handle-box {
  margin-bottom: 20px;
}

.mr10 {
  margin-right: 10px;
}

.m_t_10 {
  margin-top: 10px;
}

.m_l_10 {
  margin-left: 10px;
}
</style>